module.exports = __webpack_public_path__ + "img/Ka.fa9ddf96.png";